import { GameEdit } from "../game-edit/gameEdit.feature";

export default GameEdit;
